import React, { useEffect, useState } from 'react';

const useShareControls = ({shareEnabled, externalShareType, shareLink}) => {
    const [sharelink, setSharelink] = useState<string>(shareLink)
    const [isShareEnabled, setIsShareEnabled] = useState<boolean>(shareEnabled);
    const [isExternalSharingEnabled, setIsExternalSharingEnabled] = useState<boolean>(externalShareType === 'DisplaySharingControls')

    function updateShare(string: string) {
        setSharelink(string)
    }

    useEffect(() => {
        (window as any).functions = {...(window as any)?.functions, updateShare};

        return () => {
            delete (window as any).functions.updateShare;
        }
    }, [])
    
    useEffect(() => {
        setIsShareEnabled(shareEnabled);
    },[shareEnabled])
    
    useEffect(() => {
        setIsExternalSharingEnabled(externalShareType === 'DisplaySharingControls');
    },[externalShareType])


    // update hidden jquery from fields inline with changes in react
    useEffect(() => {
        (document.querySelector('#SharingEnabled') as HTMLInputElement).value = isShareEnabled.toString().toLowerCase();  
    }, [isShareEnabled])

    useEffect(() => {
        (document.querySelector('#ExternalShareType') as HTMLInputElement).value = Number(!isExternalSharingEnabled).toString();
    })

    const handleShareEnabled = () => {
        setIsShareEnabled(!isShareEnabled);
    }

    const handleExternalSharing = () => {
        setIsExternalSharingEnabled(!isExternalSharingEnabled);
    }

    return {isShareEnabled, isExternalSharingEnabled, sharelink, handleShareEnabled, handleExternalSharing}
}

export default useShareControls